// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cy-container {
  background: #e9e9e0;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 0.155rem 0.18rem rgba(0, 0, 0, 0.15);
  transition: 0.3s;
  cursor: pointer;
}
.cy-container:hover {
  box-shadow: 0 0.195rem 0.22rem rgba(0, 0, 0, 0.25);
}

.cy-container div * {
  left: 0;
}

.dl-icon {
  color: #2a9679;
  font-size: 200%;
  cursor: pointer;
  transition: 0.3s;
}
.dl-icon:hover {
  color: #248269;
}

.legend-icon {
  font-size: 100%;
  margin-right: 10px;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.5) !important;
  border-radius: 999px;
  padding: 0;
}

.legend-text {
  font-weight: 600;
}

.species {
  margin-left: 60px;
  align-items: left !important;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/components/Visualization/Visualization.scss","webpack://./src/scss/globals.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,mBCJW;EDKX,gBAAA;EACA,kDAAA;EACA,gBAAA;EACA,eAAA;AAFF;AAIE;EACE,kDAAA;AAFJ;;AAMA;EACE,OAAA;AAHF;;AAMA;EACE,cElBS;EFmBT,eAAA;EACA,eAAA;EACA,gBAAA;AAHF;AAKE;EACE,cEpBa;AFiBjB;;AAOA;EACE,eAAA;EACA,kBAAA;EACA,8DAAA;EACA,oBAAA;EACA,UAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,iBAAA;EACA,4BAAA;EACA,gBAAA;AAJF","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n.cy-container {\n  background: #e9e9e0;\n  border-radius: $big-radius;\n  overflow: hidden;\n  box-shadow: 0 .155rem .180rem rgba(0, 0, 0, 0.15);\n  transition: 0.3s;\n  cursor: pointer;\n\n  &:hover {\n    box-shadow: 0 .195rem .220rem rgba(0, 0, 0, 0.25);\n  }\n}\n\n.cy-container div * {\n  left: 0;\n}\n\n.dl-icon {\n  color: $palette-1;\n  font-size: 200%;\n  cursor: pointer;\n  transition: 0.3s;\n\n  &:hover {\n    color: $palette-1-dark;\n  }\n}\n\n.legend-icon {\n  font-size: 100%;\n  margin-right: 10px;\n  box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.5)!important;\n  border-radius: 999px;\n  padding: 0;\n}\n\n.legend-text {\n  font-weight: 600;\n}\n\n.species{\n  margin-left: 60px;\n  align-items: left !important;\n  text-align: left;\n}\n","$border-radius: 10px;\n$big-radius: 16px;\n$radius-btn: 10px;\n$nav-radius: 12px;\n\n$fw-light: 300;\n$fw-medium: 400;\n$fw-heavy: 500;","\n$black: #011627;\n$white: #FFFFFF;\n$palette-1:#2a9679;\n$palette-2: #6564DB;\n$palette-3: #FAF9F6;\n\n$palette-1-dark: darken($palette-1, 5%);\n$palette-1-light: lighten($palette-1, 10%);\n$palette-2-dark: darken($palette-2, 10%);\n$palette-2-light: lighten($palette-2, 10%);\n$palette-3-dark: darken($palette-3, 5%);\n$palette-3-darker: darken($palette-3, 10%);\n$palette-3-light: lighten($palette-3, 10%);\n\n$text-host: #F06543;\n$text-host-light: lighten($text-host, 15%);\n$text-pathogen: #A68F26;\n$text-pathogen-light: lighten($text-pathogen, 20%);\n\n$nav-outline: #ffffff;\n$nav-outline-hvr: #ffffff;\n\n$text-ghost: #b4b4b4;\n$text-light:#ffffff;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n// $nav-back:#4fa2a2;\n$nav-back:#288DC2;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
